import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { CareerSetup, CareerSetupParams } from '../../interfaces/career-setup.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';
import { PageResponse } from '../../interfaces/page-response.interface';

export abstract class CareerSetupService extends BaseService<CareerSetup> {
  abstract getCareerSetup(params: CareerSetupParams): Observable<CareerSetup[]>;

  abstract override findAll(params: CommonSearchParam): Observable<PageResponse<CareerSetup>>;
  abstract override find(id: string, category?: string): Observable<CareerSetup>;
  abstract override create(data: Partial<CareerSetup>): Observable<CareerSetup>;
  abstract override update(id: string, data: Partial<CareerSetup>): Observable<CareerSetup>;
  abstract override delete(id: string, category?: string): Observable<void>;
  abstract updateStatus(id: string, isActive: boolean, category?: string): Observable<CareerSetup>;
  abstract getHierarchy(industryId: string): Observable<any>;
  abstract getConfigured(industryId: string): Observable<any>;
}
